import { createStore } from 'vuex'
import { defineNuxtPlugin } from 'nuxt/app'
import storeConfig from '@/store'
import { clone } from '@/utils/helpers'

export default defineNuxtPlugin({
  name: 'vuex',
  enforce: 'pre',
  setup: (nuxtApp) => {
    console.log('SETUP VUEX STORE')
    const store = createStore(storeConfig)
    store.initialState = clone(store.state)

    store.resetState = () => {
      store.replaceState(store.initialState)
    }

    nuxtApp.vueApp.use(store)

    nuxtApp.provide('store', store)
  } })
